import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Terms() {
  return (
    <main data-testid="terms-page" className="bg-[#0A0A0A] text-white font-body min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 lg:py-28">
        <Link
          to="/"
          data-testid="terms-back-home"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-white/60 hover:text-[#FF1B91] transition-colors mb-10"
        >
          <ArrowLeft size={14} weight="bold" /> Back to Sweat With Slay
        </Link>
        <p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold mb-4">Legal</p>
        <h1 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter mb-8">
          Terms of{" "}
          <span className="font-brush font-normal normal-case text-[#FF1B91] inline-block transform -rotate-2">service.</span>
        </h1>
        <p className="text-white/50 text-sm mb-12">Last updated: February 2026</p>

        <div className="space-y-8 text-white/80 leading-relaxed text-[15px]">
          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">1. Agreement</h2>
            <p>
              By accessing sweatwithslay.com or purchasing any Sweat With Slay coaching service, you agree to these Terms of Service. If you do not agree, please do not use the site or services.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">2. Services offered</h2>
            <p>
              Sweat With Slay provides online fitness coaching, custom training programs, nutrition guidance, and accountability services delivered primarily through the Everfit app. We do not provide medical advice, diagnosis, or treatment.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">3. Medical disclaimer</h2>
            <p>
              You acknowledge that fitness and nutrition advice is not medical advice. Consult a licensed physician before starting any new exercise or nutrition program. You participate at your own risk and assume all responsibility for your health, safety, and results.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">4. Payment &amp; billing</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>All services are billed monthly unless otherwise stated.</li>
              <li>Payments are processed securely through Stripe.</li>
              <li>Pricing is subject to change with 30 days&apos; notice for existing clients.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">5. Refunds &amp; cancellations</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>You may cancel your subscription at any time — billing stops at the end of the current cycle.</li>
              <li>Refunds are not offered for partial months or already-delivered services.</li>
              <li>If the service materially fails to deliver as promised, contact us and we&apos;ll work it out one-on-one.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">6. Client conduct</h2>
            <p>
              You agree to communicate respectfully, provide accurate intake information, and follow program guidelines to the best of your ability. We reserve the right to terminate services for harassment, abuse, or non-payment.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">7. Intellectual property</h2>
            <p>
              All training programs, content, branding, and materials remain the property of Sweat With Slay. You may not redistribute, resell, or share program content without written permission.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">8. Results disclaimer</h2>
            <p>
              Individual results vary. Testimonials and example outcomes are not guarantees. Your results depend on consistency, genetics, lifestyle, and many factors outside our control.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">9. Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, Sweat With Slay is not liable for any injury, loss, or damage arising from use of the services. You waive all claims of liability against the coach and the business.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">10. Updates</h2>
            <p>
              These terms may be updated occasionally. Continued use of the site or services constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">11. Contact</h2>
            <p>
              Questions about these terms? Email{" "}
              <a href="mailto:sweatwithslay@gmail.com" className="text-[#FF1B91] hover:underline">sweatwithslay@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
